"use strict";
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
export var clear = _7a468({ defaultClassName: "SearchInput_clear__2citjx1", variantClassNames: { visible: { true: "SearchInput_clear_visible_true__2citjx2" } }, defaultVariants: {}, compoundVariants: [] });
export var container = "SearchInput_container__2citjx0";
